import type { TextFieldProps } from '@mui/material';
import LanguageCurrencyField from '../../../components/inputs/LanguageCurrencyField';

type CurrencyProps = {
  name: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
};

export const Currency = (props: CurrencyProps) => {
  const handleChange: TextFieldProps['onChange'] = (e) => {
    props.onChange(e.target.value);
  };

  return (
    <LanguageCurrencyField
      name={props.name}
      value={props.value}
      onChange={handleChange}
      errorMessage={props.error}
      disabled={props.disabled}
    />
  );
};
